module.exports = __webpack_public_path__ + "static/illustration-858754a672e32067f8a1bb5b3b521014.png";